<!--
/*
 * @Author: your name
 * @Date: 2021-07-05 20:00:34
 * @LastEditTime: 2022-11-02 18:00:36
 * @LastEditors: 谢树和 shuhe.xie@southgis.com
 * @Description: In User Settings Edit
 * @FilePath: \maine:\git\xadc\src\views\ProjectProgress\ProjectProgressSatisfyRate.vue
 * @Description: 满意度评价 - 详情
 */
 -->
<template>
  <div id="project-progress-satisfy-rate" class="project-progress-satisfy-rate">
    <div class="content-box">
      <span class="page-title">请对测绘作业单位服务做出评价</span>
      <div class="form-box">
        <div class="rate-panel">
          <div class="rate-title">业务编号</div>
          <div class="rate-bar">{{ params.YWBH }}</div>
        </div>
        <div class="rate-panel" v-if="params.CLSX">
          <div class="rate-title">测量事项</div>
          <div class="rate-bar">{{ params.CLSX }}</div>
        </div>
        <div class="rate-panel" v-if="params.HJINDEX">
          <div class="rate-title">汇交次数</div>
          <div class="rate-bar">{{ params.HJINDEX }}</div>
        </div>
        <div class="rate-panel" v-for="(item, index) of list" :key="index">
          <div class="rate-title">{{ item.label }}</div>
          <div class="rate-bar">
            <van-rate
              v-model="params[item.key]"
              :size="23"
              color="#ffd21e"
              void-icon="star"
              void-color="#eee"
              gutter="20px"
              :count="item.count"
              :readonly="isEnabled"
            />
          </div>
        </div>
        <van-cell title="评价内容" />
        <div class="">
          <van-field
            v-model="params.FWPY"
            rows="6"
            autosize
            type="textarea"
            maxlength="255"
            placeholder="(限255字)"
            class="border-message"
            :readonly="isEnabled"
          />
        </div>

        <!-- <van-button
            class="btn-submit"
            :color="{isSubmit ? '#1D84FF' :'#CFCFCF' }"
            block
            @click.stop="btnSubmit"
            >提交</van-button
          > -->

        <div class="btn-group">
          <van-button
            class="btn-submit"
            color="#1D84FF"
            block
            @click.stop="btnSubmit"
            v-if="!isEnabled"
            >提交</van-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import listMixins from '@/mixins/comListMixins'
import api from '@/utils/api/projectProgress.api.js'
import moduleMixins from '@/mixins/moduleMixins'
export default {
  name: 'projectProgressSatisfyRate',
  mixins: [listMixins, moduleMixins],
  components: {},
  props: {},
  data() {
    return {
      params: {
        FWPY: '', // 评价内容
      },
      statusType: '', // 是否可编辑类型值
      isEnabled: false, // 是否禁用 true则允许编辑，false则禁用
      isSubmit: false, // 是否允许提交
      list: [],
      title: ''
    }
  },
  watch: {},
  computed: {
    navTitle() {
      return this.title
    }
  },
  filters: {},
  methods: {
    loadData() {
      this.getRateData()
    },
    getRateData() {
      api
        .getSatisfactionItem()
        .then(res => {
          let data = res.data
          data.forEach(item => {
            item.count = item.value.length ? item.value.length : 5
            this.params[item.key] = Number(this.params[item.key])
            console.log('item', item)
          })
          this.list = data
        })
        .catch(err => {
          //登录超时
          if (err.response.data.code == 401) {
            //弹出登录窗
            this.$dialog
              .confirm({
                title: '温馨提示',
                message: err.response.data.msg,
                confirmButtonText: '去登录',
                confirmButtonColor: '#1D84FF'
              })
              .then(() => {
                this.$router.push({
                  name: 'Login'
                })
              })
              .catch(() => {
                // on cancel
                this.$router.go(-1)
              })
          } else {
            this.$toast(err.response.data.msg)
          }
        })
    },
    btnSubmit() {
      // 提交
      console.log('params:', this.params)
      // return
      api[this.params.CLSX ? 'rateSubmit' : 'allRateSubmit'](this.params)
        .then(res => {
          console.log("getSatisfactionItem res:",res)
          this.isSubmit = true
          this.$toast.success('提交成功')
          this.$router.go(-1)
        })
        .catch(() => {})
    }
  },
  created() {},
  mounted() {
    this.title = ['点击评价', '评价'].includes(this.$route.params.title) ? '满意度评价' : '查看评价'
    this.isEnabled = ['点击评价', '评价'].includes(this.$route.params.title) ? false : true
    this.params = this.$route.params.data
  },
  activated() {
    this.loadData()
  }
}
</script>
<style lang="scss" scoped>
.project-progress-satisfy-rate {
  background: #ffffff;
  height: 100vh;
  overflow: auto;
  .page-title {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 17px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #333333;
    height: 70px;
  }
  .content-box {
    // height: 15vw;
    /* line-height: 15vw; */
    margin: 0 16px;
    .rate-panel {
      display: flex;
      align-items: center;
      height: 48px;
      .red-star {
        color: #fa6366;
      }
      .rate-title {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #333333;
        padding: 0 15px;
        position: relative;
        display: flex;
        align-items: center;
        width: 25%;
      }
      .rate-title::before {
        content: '*';
        color: #fa6366;
        font-size: 14px;
        position: absolute;
        font-weight: 500;
        top: 2px;
        left: 0;
      }
    }

    .btn-group {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      padding: 30px 0px 20px 0px;
      .btn-submit {
        width: 92vw;
      }
    }
    .border-message {
      border: 1px solid #dddddd;
    }
  }
}
</style>
